// Documents that must be created in Firestore
export const FS_PATH_BACKEND_AUTH_USERS = '/backend/auth/users';
export const FS_PATH_USER_APP_CONFIGS = '/user/{uid}/app-configs';
export const FS_PATH_APP_CONFIGS = '/app-configs';
export const FS_PATH_APP_CONFIG = '/app-configs/{abbrv}';
export const FS_PATH_SCENE_CONFIGS = '/app-configs/{abbrv}/sceneConfigs';
export const FS_PATH_TEAMS = '/teams';
export const FS_PATH_TEAM = '/teams/{abbrv}';
export const FS_PATH_TEAM_ALL_MATCHES_MINIMIZED = '/teams/{abbrv}/all-matches-minimized';
export const FS_PATH_WIFI_VENUE_CONFIG = '/wifi/sv/venue-configs';
export const FS_PATH_FOTBOLL_PLAY_TEAM_CONFIG = '/fotbollplay/config/teams/{abbrv}';
export const FS_PATH_MATCHES_CONFIG = '/leagues/{leagueAbbrv}/seasons/{season}/matches-config';
export const FS_PATH_MATCHES_MINIMIZED =
  '/leagues/{leagueAbbrv}/seasons/{season}/matches-minimized';
export const FS_PATH_MATCH = '/leagues/{leagueAbbrv}/seasons/{season}/matches/{matchId}';
export const FS_PATH_NOTIFICATIONS_LOG =
  '/log-v3/firebase-triggers/triggers/{type}/notifications/{abbrv}/logs';
export const FS_PATH_POLLS = '/polls';
export const FS_PATH_POLL = '/polls/{id}';
export const FS_PATH_STORIES = '/stories';
export const FS_PATH_STORY = '/stories/{id}';
export const FS_PATH_FAQ_ARTICLES = '/faq/sv/articles';
export const FS_PATH_FAQ_ARTICLE = '/faq/sv/articles/{id}';
export const FS_PATH_FAQ_MAPPINGS = '/faq/sv';
export const FS_PATH_PUSH_NOTIFICATION_CONTENT_CONNECTION = '/push-content-connection';

export const drawerWidth = 292;
